// Phase-1 product-scope panel.
// Renders side-by-side "Included" (gold check) and "Not included" (muted X)
// lists so customers see exactly what arrives in the ₹4,999 Full Concept
// Layout Package — and exactly what they need to commission separately
// (Elevations / MEP / Structural).
import React from "react";
import { Check, X } from "lucide-react";
import { t } from "@/i18n";

export const Phase1Scope = ({ lang, testId = "phase1-scope" }) => {
  const included = [
    t(lang, "phase1_inc_1"),
    t(lang, "phase1_inc_2"),
    t(lang, "phase1_inc_3"),
    t(lang, "phase1_inc_4"),
  ];
  const excluded = [
    t(lang, "phase1_exc_1"),
    t(lang, "phase1_exc_2"),
    t(lang, "phase1_exc_3"),
    t(lang, "phase1_exc_4"),
  ];
  return (
    <div
      data-testid={testId}
      className="rounded-2xl border-2 border-navy/10 bg-white grid sm:grid-cols-2 gap-0 overflow-hidden"
    >
      <div className="p-4 border-r border-navy/10">
        <div className="text-[10.5px] uppercase tracking-[0.2em] text-gold-dark font-extrabold">
          {t(lang, "phase1_inc_title")}
        </div>
        <ul className="mt-2 space-y-1.5">
          {included.map((line) => (
            <li
              key={line}
              className="flex items-start gap-2 text-[13px] text-navy/90 leading-snug"
            >
              <span className="mt-0.5 h-4 w-4 rounded-full bg-gold/20 text-gold-dark grid place-items-center shrink-0">
                <Check className="h-3 w-3" strokeWidth={3} />
              </span>
              {line}
            </li>
          ))}
        </ul>
      </div>
      <div className="p-4 bg-navy/[0.025]">
        <div className="text-[10.5px] uppercase tracking-[0.2em] text-muted-foreground font-extrabold">
          {t(lang, "phase1_exc_title")}
        </div>
        <ul className="mt-2 space-y-1.5">
          {excluded.map((line) => (
            <li
              key={line}
              className="flex items-start gap-2 text-[13px] text-muted-foreground leading-snug line-through decoration-muted-foreground/40"
            >
              <span className="mt-0.5 h-4 w-4 rounded-full bg-muted text-muted-foreground grid place-items-center shrink-0 no-underline">
                <X className="h-3 w-3" strokeWidth={3} />
              </span>
              <span className="no-underline">{line}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Phase1Scope;
